import React, { useState } from "react";
import { Button, Alert } from "react-bootstrap";
import Select from 'react-select';

import Loader from "components/Loader";
import { useK2Loader } from "hooks/useK2Loader";
import K2Api from 'lib/ajax/K2Api';

const k2Api = new K2Api();

function ProfileLabelsForm(props) {
	const { profile: { id: profileId, labels: profileLabels }, type: profileType } = props;

	const [originalLabels, setOriginalLabels] = useState(profileLabels);
	const [workingLabels, setWorkingLabels] = useState(profileLabels);
	const [isLabelsUpdated, setIsLabelsUpdated] = useState(false);
	const [errors, setErrors] = useState(null);
	const [loading, labelsResponse, labelsError] = useK2Loader('/labels');

	const onSubmit = () => {
		if (errors) setErrors(null);
		deleteLabels(profileId, profileType, originalLabels, workingLabels, setErrors);
		saveLabels(profileId, profileType, originalLabels, workingLabels, setErrors);

		setOriginalLabels(workingLabels);
		setIsLabelsUpdated(false);
	}

	const onDiscard = () => {
		setWorkingLabels(originalLabels);
		setIsLabelsUpdated(false);
	}

	const onChange = (selectedLabels) => {
		if (!selectedLabels.length) {
			setIsLabelsUpdated(false);
		} else {
			setIsLabelsUpdated(true);
		}

		setWorkingLabels(
			selectedLabels.map(item => { return { id: item.value, name: item.label } })
		);
	}

	const renderEditButtons = () => {
		let buttons;
		if (isLabelsUpdated) {
			buttons = (
				<div id="profile-labels-form-buttons" className="mt-1 float-right">
					<Button className="btn-sm mr-1" variant="success" onClick={onSubmit}>Submit</Button>
					<Button className="btn-sm" variant="danger" onClick={onDiscard}>Discard</Button>
				</div>
			);
		}
		return buttons;
	}

	if (loading) return <Loader />;
	if (labelsError) return <Alert variant="danger"><p className='m-2'>{labelsError}</p></Alert>;

	return (
		<>
			<Select
				value={
					!workingLabels ? null : workingLabels.map(label => { return { label: label.name, value: label.id } })
				}
				options={labelsResponse.map(label => { return { label: label.name, value: label.id } })}
				onChange={onChange}
				isMulti={true}
				closeMenuOnSelect={false}
				styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
				isClearable={false}
			/>
			{renderEditButtons()}
			{errors ? <p className="mb-0 text-warning"><em>{errors}</em></p> : null}
		</>
	);
}

async function saveLabels(id, profileType, originalLabels, selectedLabels, onErrors) {
	let newLabels;
	if (originalLabels) {
		newLabels = selectedLabels.filter(a => !originalLabels.some(b => a.id === b.id));
	} else {
		newLabels = selectedLabels;
	}

	const promises = newLabels.map(label => {
		const promise = k2Api.put(`/socialmedia/${profileType}/${id}/labels/${label.id}`);
		promise.catch(error => {
			onErrors(prevErrors => [...prevErrors, error.response.data]);
		});
		return promise;
	});

	await Promise.allSettled(promises);
}

async function deleteLabels(id, profileType, originalLabels, selectedLabels, onErrors) {
	const deletedLabels = originalLabels.filter(a => !selectedLabels.some(b => a.id === b.id));
	if (!deletedLabels) return;

	const promises = deletedLabels.map(label => {
		const promise = k2Api.delete(`/socialmedia/${profileType}/${id}/labels/${label.id}`);
		promise.catch(error => {
			onErrors(prevErrors => [...prevErrors, error.response.data]);
		});
		return promise
	});

	await Promise.allSettled(promises);
}

export default ProfileLabelsForm;
